<template>
  <div id="crew-dm-date-picker">
    <div class="date-picker-form">
      <div class="date-input start-date_block">
        <label class="block aisea-text-14-600-black mb-2"
          >{{ label }} <span v-if="required" style="color: red;">*</span></label
        >
        <div class="input-group">
          <a title="toggle" data-toggle>
            <feather-icon
              class="input-calendar-icon"
              icon="CalendarIcon"
              svgClasses="h-4 w-4"
            />
          </a>

          <flat-pickr
            :placeholder="placeholder"
            v-model="localValue.dateStart"
            :config="localConfigs"
            @on-change="onChange"
            readonly="readonly"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import DateUtil from "@/utils/DateUtil.js";

export default {
  name: "DatePicker",
  components: {
    flatPickr,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        dateStart: null,
        dateEnd: null,
      }),
    },
    id: { type: String, required: true },
    label: {
      type: String,
      default: "",
    },
    required: Boolean,
    placeholder: {
      type: String,
      default: "選択してください...",
    },
    config: {
      type: Object,
      default: () => ({
        dateFormat: "Y-m-d",
        enableTime: false,
        locale: Japanese,
        mode: "single",
        minDate: new Date(),
        maxDate: new Date(),
        defaultDate: new Date(),
      }),
    },
  },
  data() {
    return {
      localValue: { ...this.value },
      localConfigs: {},
    };
  },
  created() {
    this.localConfigs = {
      ...this.config,
      minDate: DateUtil.formatDateByConfig(this.config.minDate),
      maxDate: DateUtil.formatDateByConfig(this.config.maxDate),
      defaultDate: DateUtil.formatDateByConfig(this.config.defaultDate),
      wrap: true,
    };

    // デフォルトデータでDialogComponentの必須チェックを発火させるためonChange実行
    if (this.localConfigs.defaultDate && this.required) {
      this.onChange([this.localConfigs.defaultDate]);
    }
  },
  methods: {
    onChange(selectedDates) {
      if (selectedDates.length === 0) {
        this.$emit("input", { id: this.id, value: null });
        return;
      }

      this.$emit("input", {
        id: this.id,
        value: {
          // flatpickrで取れるデータUTCのため、JSTに変更する
          dateStart:
            DateUtil.formatDateWithTimezone(
              selectedDates[0],
              "YYYY-MM-DD",
              "Asia/Tokyo"
            ) || null,
          dateEnd:
            DateUtil.formatDateWithTimezone(
              selectedDates[1],
              "YYYY-MM-DD",
              "Asia/Tokyo"
            ) || null,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-dm-date-picker {
  .date-picker-form {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    .start-date_block {
      flex: 1;
    }

    .separator_block {
      flex: none;
      font-size: 16px;
      font-weight: bold;
      margin-top: 25px;
    }

    .end-date_block {
      flex: 1;
    }
  }

  .date-input {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .input-group {
    position: relative;
    display: flex;
    width: 100%;
  }

  .input-calendar-icon {
    position: absolute;
    top: -0.05rem;
    right: 0;
    cursor: pointer;
    padding: 0.8rem 0.9rem 0.8rem 0.8rem;
    border: none;
    background: none;
    color: #ccc;
    font-size: 1rem;
    transition: 0.5s;

    :hover {
      color: $aisea-gray-black !important;
    }
  }

  .date-input input {
    width: 100%;
    padding: 8px;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #ccc;
    border-radius: 4px;
    color: $aisea-gray-black;
  }
}
.flatpickr-calendar {
  .flatpickr-months {
    span.cur-month {
      color: #626262;
    }

    svg:hover {
      fill: $aisea-gray-black !important;
    }
  }

  .flatpickr-day {
    &.selected,
    &.startRange,
    &.endRange,
    &.selected.inRange,
    &.startRange.inRange,
    &.endRange.inRange,
    &.selected:focus,
    &.startRange:focus,
    &.endRange:focus,
    &.selected:hover,
    &.startRange:hover,
    &.endRange:hover,
    &.selected.prevMonthDay,
    &.startRange.prevMonthDay,
    &.endRange.prevMonthDay,
    &.selected.nextMonthDay,
    &.startRange.nextMonthDay,
    &.endRange.nextMonthDay {
      background: $aisea-blue !important;
      -webkit-box-shadow: none;
      box-shadow: none;
      border-color: $aisea-blue !important;
    }

    .inRang {
      cursor: pointer;
      background: $aisea-blue !important;
      border-color: $aisea-blue !important;
    }
  }
}

.flatpickr-input.active {
  border-color: rgba(2, 5, 0, 0.2) !important;
}
</style>